import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCourses } from '../api';
import './SkillsGrid.css';

const SkillsGrid = () => {
  const [skills, setSkills] = useState([]);
  const [showAll, setShowAll] = useState(false); // Estado para controlar si vemos todos o no

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCourses();
        // Filtramos solo los GRATIS y los invertimos para ver los más nuevos primero
        const freeCourses = response.data.filter(course => course.is_free === true).reverse();
        setSkills(freeCourses);
      } catch (error) {
        console.error("Error cargando habilidades:", error);
      }
    };
    fetchData();
  }, []);

  // Si showAll es true, mostramos todos. Si es false, solo los primeros 3.
  const visibleSkills = showAll ? skills : skills.slice(0, 3);

  return (
    <div className="skills-section-wrapper">
      
      <div className="skills-grid-container">
        {visibleSkills.length > 0 ? (
          visibleSkills.map((skill) => (
            <Link to={`/skills/${skill.id}`} key={skill.id} className="skill-card-link">
              {/* Usamos style inline para la imagen de fondo dinámica */}
              <div 
                className="skill-card" 
                style={{
                  backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.85)), url(${skill.card_image_url || '/images/default-course.jpg'})`
                }}
              >
                <div className="skill-header-card">
                  <span className={`skill-badge ${skill.category}`}>
                    {skill.category === 'python' ? 'Python' : 'Webinar'}
                  </span>
                  {/* Iconos blancos ahora */}
                  {skill.category === 'python' ? <i className="fab fa-python icon-white"></i> : <i className="fas fa-video icon-white"></i>}
                </div>
                
                <div className="skill-content-bottom">
                  <h3>{skill.title}</h3>
                  <p>{skill.short_description}</p>
                  
                  <div className="skill-footer">
                    <span className="free-tag">Gratis</span>
                    <span className="arrow-link">Ver clase →</span>
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : (
          <p>Cargando habilidades...</p>
        )}
      </div>

      {/* Botón para expandir/colapsar si hay más de 3 cursos */}
      {skills.length > 3 && (
        <div className="view-all-container">
          <button 
            className="btn-view-all" 
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Ver menos' : 'Ver todo el catálogo gratis'}
          </button>
        </div>
      )}
    </div>
  );
};

export default SkillsGrid;